import { classed } from "@frend-digital/ui";
import styles from "./Divider.module.css";

export const Divider = classed("hr", styles.root);
